import {ValidationError} from '../../models/validation-error.model';
import {ProductBase} from '../../models/product.model';
import {ValidationUploadFileErrors} from '../../models/validation-upload-file-errors';
import {ProductCpi} from '../../models/product-cpi.model';

export namespace ProductCpiActions {

    export class GetOne {
        static readonly type = 'ProductCpiActions.GetOne';

        constructor(public id: number) {
        }
    }

    export class Duplicate {
        static readonly type = 'ProductCpiActions.Duplicate';

        constructor(public id: number, public data: ProductBase) {
        }
    }

    export class Update {
        static readonly type = 'ProductCpiActions.Update';

        constructor(public product: ProductCpi) {
        }
    }

    export class Merge {
        static readonly type = 'ProductCpiActions.Merge';

        constructor(public readonly product: ProductCpi) {
        }
    }

    export class FormFailure {
        static readonly type = 'ProductCpiActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class MergeFailure {
        static readonly type = 'ProductCpiActions.MergeFailure';

        constructor(public readonly uploadFileErrors: ValidationUploadFileErrors[]) {
        }
    }

    export class DownloadFile {
        static readonly type = 'ProductCpiActions.DownloadFile';

        constructor(public hash: string) {
        }
    }

    export class PolicyTemplatesList {
        static readonly type = 'ProductCpiActions.PolicyTemplatesList';
    }


    export class Clear {
        static readonly type = 'ProductCpiActions.Clear';
    }

    export class ClearValidationErrors {
        static readonly type = 'ProductCpiActions.ClearValidationErrors';

        constructor(public readonly fields: string[] = []) {
        }
    }

    export class AvailableStatusesList {
        static readonly type = 'ProductCpiActions.AvailableStatusesList';

        constructor(public id: number) {
        }
    }

}
